import { useFormContext } from 'react-hook-form';
import CheckboxGroupInput from '@/components/form/CheckboxGroupInput.tsx';
import { Card, CardContent, InnerCardHeader } from '@/components/ui/Card.tsx';
import { TourInstallmentInputForm } from '@/features/dashboard/tourConfig/schemas/tourInstallmentsSchema.ts';
import { tourConfigInstallmentsRoute } from '@/features/dashboard/tourConfig/routes/tourConfigInstallmentsRoute.ts';
import { getPossiblePaymentsMethods } from '@/features/dashboard/tourConfig/types/PaymentMethod.utils.ts';
import { TotalPriceSummary } from '@/features/dashboard/tourConfig/components/TotalPriceRangeSummary.tsx';
import useBankAccountSync from '@/features/dashboard/tourConfig/hooks/useBankAccountSync.ts';
import useOnlinePaymentGuard from '@/features/dashboard/tourConfig/hooks/useOnlinePaymentGuard.ts';

const FullOneTimePaymentCard = () => {
  const { tourId } = tourConfigInstallmentsRoute.useParams();
  const { onPaymentMethodsChange } = useBankAccountSync();
  const { guardOnlinePayment } = useOnlinePaymentGuard(
    'installments.0.paymentMethods',
  );

  const {
    control,
    formState: { errors },
  } = useFormContext<TourInstallmentInputForm>();

  return (
    <Card>
      <InnerCardHeader>
        <p className="text-sm font-semibold">Cała płatność</p>
      </InnerCardHeader>
      <CardContent className="space-y-2">
        <p className="text-xs text-neutral-500">
          Płatność jest pobierana od razu po rejestracji w przypadku bramki
          płatności lub w ciągu 3 dni w przypadku płatności gotówką lub
          przelewem tradycyjnym.
        </p>
        <CheckboxGroupInput
          fieldPath={`installments.0.paymentMethods`}
          label="Sposób płatności"
          required
          control={control}
          options={getPossiblePaymentsMethods()}
          error={errors.installments?.[0]?.paymentMethods?.message}
          onChange={(values) => {
            guardOnlinePayment(values);
            onPaymentMethodsChange();
          }}
        />
        <TotalPriceSummary tourId={tourId} />
      </CardContent>
    </Card>
  );
};

export default FullOneTimePaymentCard;
